const fonts = {
  bold: 'NotoSans-Bold',
  regular: 'NotoSans-Regular',
  italic: 'NotoSans-Italic'
};

export default fonts;